<div class="report-model">
   <app-datatable-title [title] = "tableHeading" [isShowCount]="false"></app-datatable-title>

  
    <app-report-datatable
        [showLoader]="!rentUnitSizeWiseLoading"
        [tableColumns]="rentUnitSizeWiseColumn"
        class="default-table-view"
        [ngClass]="{activeTable: tableName == 1 }"
        (lastClickedTable)="lastClickedTable($event, 1)"
        [dataLength]="rentUnitSizeWiseCount"
        [tableData]="rentUnitSizeTableData"
        (pageEvent)="onPageEvent($event)"
        (sort)="sortData($event)"
        [allowExcelDownload]="true"
        (excelDownload)="downloadExcel()"
        [dropDownOption]="rentunitSizeDropDown"
        (dropDownValue)="dropDownChange($event)"
        [downloadLoading]="downloadLoading"
        [showEstaterText]="true" [showTooltip]="true"
        [show_step_count]="false"
        [reportSectionTitle]="''"
        >
    </app-report-datatable>
</div>

